import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogFreeTimeComponent } from './dialog-free-time.component';
import { MatDialogModule } from '@angular/material/dialog';



@NgModule({
  declarations: [
    DialogFreeTimeComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule
  ]
})
export class DialogFreeTimeModule { }
